
$.validator.addMethod( "email", function( value, element ) {
    return this.optional( element ) || /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test( value );
});

$.validator.setDefaults({
    errorElement: "label",
    errorClass: "has-error",
    validClass: "has-success",
    focusInvalid: false,
    focusCleanup: false,
    onkeyup: false,
    errorPlacement: function(error, element) {
        //  $(element).after(error);
    },
    unhighlight: function(element, errorClass, validClass) {
        $(element).closest('.form-group').removeClass(errorClass).addClass(validClass);
    },
    highlight: function(element, errorClass, validClass) {
        $(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
    },
    invalidHandler: function(event, validator, temp) {
        // $(validator.currentForm).find('.form-group-action .btn').addClass('disabled');
    }
});